import React, {ReactElement} from "react";
import {Table, TableBody, TableCell, TableRow} from "@mui/material";

export const ConfirmedTable = ({
                             item,
                           }: {
  item: any;
}): ReactElement => {

  return (
    <Table sx={{
      width: '100%'
    }} aria-label="simple table">
      <TableBody
        sx={{
          '& tr:last-child td, & tr:last-child th': {
            border: 0
          },
          ' .MuiTableCell-root': {
            padding: '2px',
          }
        }}
      >

        {item?.service_provider?.name && (
          <TableRow>
            <TableCell component="th" scope="row">
              Szolgáltató:
            </TableCell>
            <TableCell sx={{
              fontWeight: 'bold'
            }} dangerouslySetInnerHTML={{__html: item?.service_provider?.name}}></TableCell>
          </TableRow>
        )}

        <TableRow>
          <TableCell component="th" scope="row">
            Típus:
          </TableCell>
          <TableCell sx={{
            fontWeight: 'bold'
          }} dangerouslySetInnerHTML={{__html: item?.type}}></TableCell>
        </TableRow>

        <TableRow>
          <TableCell component="th" scope="row">
            Szolgáltatás:
          </TableCell>
          <TableCell
            dangerouslySetInnerHTML={{__html: item?.service}}
          ></TableCell>
        </TableRow>

        {item.formatted?.custom_fields && item.formatted.custom_fields.map((customField:any)=>{

          return (
            <TableRow>
              <TableCell component="th" scope="row">
                {customField?.column?.name}:
              </TableCell>
              <TableCell
                dangerouslySetInnerHTML={{__html: (customField?.value?.name ? customField?.value?.name : customField?.value)}}
              ></TableCell>
            </TableRow>
          );

        })}

      </TableBody>
    </Table>
  );

}